import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { OtpPage } from './otp/otp.page';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { MobileVerifyComponent } from './mobile-verify/mobile-verify.component';
import { SuccessfulCreatedComponent } from './successful-created/successful-created.component';
import { AddProductsComponent } from './add-products/add-products.component';
import { MyProductlistComponent } from './my-productlist/my-productlist.component';
import { AddProductSubformComponent } from './add-product-subform/add-product-subform.component';
import { OrdersProductComponent } from './orders-product/orders-product.component';
import { OrderConfirmComponent } from './order-confirm/order-confirm.component';
import { DeclarationComponent } from './declaration/declaration.component';
import { NavbarHeaderComponent } from './navbar-header/navbar-header.component';
import { ProductsComponent } from './products/products.component';
import { CategoryNavComponent } from './category-nav/category-nav.component';
import { PaymentOptionComponent } from './payment-option/payment-option.component';
import { SelectProductComponent } from './select-product/select-product.component';
import { DatetimeModelComponent } from './datetime-model/datetime-model.component';
import { ProductSliderComponent } from './product-slider/product-slider.component';
import { InformationProductComponent } from './information-product/information-product.component';
import { CategoryFilterComponent } from './category-filter/category-filter.component';
import { ProductDetailsComponent } from './product-details/product-details.component';
import { ShopTagComponent } from './shop-tag/shop-tag.component';
import { SortByComponent } from './sort-by/sort-by.component';
import { SortByButtonComponent } from './sort-by-button/sort-by-button.component';
import { OrderReviewProductComponent } from './order-review-product/order-review-product.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { TabsComponent } from './tabs/tabs.component';
import { ProductsSkeletonComponent } from './products-skeleton/products-skeleton.component';
import { BannerSkeletonComponent } from './banner-skeleton/banner-skeleton.component';
import { NoProductComponent } from './no-product/no-product.component';
import { AddMoreInfoComponent } from './add-more-info/add-more-info.component';
import { AddLocationComponent } from './add-location/add-location.component';
import { RatingPage } from './rating/rating.page';
import { SocailMobileVerifiedComponent } from './socail-mobile-verified/socail-mobile-verified.component';
import { AddMoneyComponent } from './add-money/add-money.component';
import { ImageModalComponent } from './image-modal/image-modal.component';
import { ProductImageModalComponent } from './product-image-modal/product-image-modal.component';
import { BecomeCompanySellerComponent } from './become-company-seller/become-company-seller.component';
import { VideoModalComponent } from './video-modal/video-modal.component';
import { AddToCartComponent } from './add-to-cart/add-to-cart.component';
import { CustomCurrencyPipeModule } from '../currency.pipe.module';
import { AdvertisementComponent } from './advertisement/advertisement.component';
import { FooterComponent } from './footer/footer.component';
import { CategoryHeaderComponent } from './category-header/category-header.component';
import { StoreCategoryFilterComponent } from './store-category-filter/store-category-filter.component';
import { SortAndFilterComponentComponent } from './sort-and-filter-component/sort-and-filter-component.component';
import { RelatedProductComponent } from './related-product/related-product.component';
import { BankTransferComponent } from './bank-transfer/bank-transfer.component';
import { PaymentSuccessModalComponent } from './payment-success-modal/payment-success-modal.component';
import { RentDateModalComponent } from './rent-date-modal/rent-date-modal.component';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  declarations: [
    OtpPage,
    MobileVerifyComponent,
    SuccessfulCreatedComponent,
    AddProductsComponent,
    MyProductlistComponent,
    AddProductSubformComponent,
    OrdersProductComponent,
    OrderConfirmComponent,
    DeclarationComponent,
    NavbarHeaderComponent,
    ProductsComponent,
    CategoryNavComponent,
    PaymentOptionComponent,
    SelectProductComponent,
    DatetimeModelComponent,
    ProductSliderComponent,
    InformationProductComponent,
    CategoryFilterComponent,
    ProductDetailsComponent,
    ShopTagComponent,
    SortByComponent,
    SortByButtonComponent,
    OrderReviewProductComponent,
    BreadcrumbComponent,
    TabsComponent,
    ProductsSkeletonComponent,
    BannerSkeletonComponent,
    NoProductComponent,
    AddMoreInfoComponent,
    AddLocationComponent,
    RatingPage,
    SocailMobileVerifiedComponent,
    AddMoneyComponent,
    ImageModalComponent,
    ProductImageModalComponent,
    BecomeCompanySellerComponent,
    VideoModalComponent,
    AddToCartComponent,
    AdvertisementComponent,
    FooterComponent,
    CategoryHeaderComponent,
    StoreCategoryFilterComponent,
    SortAndFilterComponentComponent,
    RelatedProductComponent,
    BankTransferComponent,
    PaymentSuccessModalComponent,
    RentDateModalComponent,
  ],

  exports: [
    OtpPage,
    MobileVerifyComponent,
    SuccessfulCreatedComponent,
    AddProductsComponent,
    MyProductlistComponent,
    AddProductSubformComponent,
    OrdersProductComponent,
    OrderConfirmComponent,
    DeclarationComponent,
    NavbarHeaderComponent,
    ProductsComponent,
    CategoryNavComponent,
    PaymentOptionComponent,
    SelectProductComponent,
    DatetimeModelComponent,
    ProductSliderComponent,
    InformationProductComponent,
    CategoryFilterComponent,
    ProductDetailsComponent,
    ShopTagComponent,
    SortByComponent,
    SortByButtonComponent,
    OrderReviewProductComponent,
    BreadcrumbComponent,
    TabsComponent,
    ProductsSkeletonComponent,
    BannerSkeletonComponent,
    NoProductComponent,
    AddMoreInfoComponent,
    AddLocationComponent,
    RatingPage,
    SocailMobileVerifiedComponent,
    AddMoneyComponent,
    ImageModalComponent,
    ProductImageModalComponent,
    BecomeCompanySellerComponent,
    VideoModalComponent,
    AddToCartComponent,
    AdvertisementComponent,
    FooterComponent,
    CategoryHeaderComponent,
    StoreCategoryFilterComponent,
    SortAndFilterComponentComponent,
    RelatedProductComponent,
    BankTransferComponent,
    PaymentSuccessModalComponent,
    RentDateModalComponent,
  ],

  imports: [
    TranslateModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    CustomCurrencyPipeModule,
  ],
})
export class SharedComponentsModule {}
